import { render, staticRenderFns } from "./heart_rate.vue?vue&type=template&id=4867531a&scoped=true&"
import script from "./heart_rate.vue?vue&type=script&lang=js&"
export * from "./heart_rate.vue?vue&type=script&lang=js&"
import style0 from "./heart_rate.vue?vue&type=style&index=0&id=4867531a&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4867531a",
  null
  
)

export default component.exports